import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-100f7dd7")

_pushScopeId("data-v-100f7dd7")
const _hoisted_1 = { class: "relative w-full lg:w-120 overflow-y-auto" }
const _hoisted_2 = { class: "w-full flex flex-row gap-x-6 pt-2 pb-8" }
const _hoisted_3 = { class: "p-field-radiobutton gap-x-3 flex flex-row lp-radio" }
const _hoisted_4 = { for: "radio-active-status-account" }
const _hoisted_5 = { class: "p-field-radiobutton gap-x-3 flex flex-row lp-radio" }
const _hoisted_6 = { for: "radio-inactive-status-account" }
const _hoisted_7 = { class: "bg-gray-lp-200 p-3 mb-12 rounded-md" }
const _hoisted_8 = { class: "flex items-start gap-x-3" }
const _hoisted_9 = { class: "text-12px xxl:text-14px font-normal text-gray-lp-800" }
const _hoisted_10 = {
  key: 3,
  class: "h-full",
  style: {"height":"230px"}
}
const _hoisted_11 = { class: "flex justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "model-value": _ctx.modelValue,
    persistent: true,
    title: _ctx.title,
    "onUpdate:modelValue": _ctx.toggleModalEditDetail
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.type === 'email')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('userManagement.modalEditDetail.oldEmail'),
                class: "mb-4"
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    disabled: true,
                    "disable-background": true,
                    modelValue: _ctx.oldEmail,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.oldEmail = $event)),
                    placeholder: 
              _ctx.$t('userManagement.modalEditDetail.placeholderNewEmail')
            ,
                    type: "email"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('userManagement.modalEditDetail.newEmail'),
                class: "mb-8"
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.newEmail,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newEmail = $event)),
                    placeholder: 
              _ctx.$t('userManagement.modalEditDetail.placeholderNewEmail')
            ,
                    type: "email"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type === 'status')
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_RadioButton, {
                    id: "radio-active-status-account",
                    name: "status-account",
                    value: "active",
                    modelValue: _ctx.statusAccount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.statusAccount = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("userManagement.modalEditDetail.active")), 1)
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_RadioButton, {
                    id: "radio-inactive-status-account",
                    name: "status-account",
                    value: "inactive",
                    modelValue: _ctx.statusAccount,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.statusAccount = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("userManagement.modalEditDetail.inactive")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("img", {
                    src: require(`@/app/ui/assets/svg/info-red.svg`),
                    class: "ml-2 w-5",
                    alt: "info"
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("userManagement.modalEditDetail.statusInfo")), 1)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type === 'role')
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 2,
              label: _ctx.$t('userManagement.modalEditDetail.selectRole'),
              class: "mb-8"
            }, {
              default: _withId(() => [
                _createVNode(_component_CustomDropdown, {
                  selectedItem: _ctx.roleDefault,
                  options: _ctx.roleData,
                  placeholder: _ctx.$t('userManagement.modalEditDetail.selectRole'),
                  class: "mt-2",
                  onSelect: _ctx.setRoleDefault
                }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.type === '3lc')
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_MultipleSelectSearch, {
                id: "multiple-select-search_3LC_detail-user",
                "modal-title": _ctx.$t('userManagement.modalEditDetail.modal3lcTitle'),
                "option-name": _ctx.$t('userManagement.modalEditDetail.cityOptionName'),
                customDisplayAll: _ctx.$t('userManagement.modalEditDetail.all'),
                onFocus: _ctx.fetchCity,
                onFilter: _ctx.filterCity,
                options: _ctx.cityOptions,
                modelValue: _ctx.assigned3lc,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.assigned3lc = $event)),
                keyName: "name",
                keyValue: "value",
                placeholder: 
              _ctx.$t('userManagement.modalEditDetail.searchOrSelect3lc')
            ,
                showReset: "",
                onChange: ($event: any) => (
              {
              }
            ),
                class: "mt-2",
                "able-to-delete-in-modal": "",
                useInfiniteScroll: "",
                onScrolled: _ctx.fetchCityinfiniteScroll
              }, null, 8, ["modal-title", "option-name", "customDisplayAll", "onFocus", "onFilter", "options", "modelValue", "placeholder", "onScrolled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === 'hub')
          ? (_openBlock(), _createBlock("div", {
              key: 4,
              style: { height: _ctx.focusHub ? '147px' : '46px' }
            }, [
              _createVNode(_component_SelectSearch, {
                isLoading: _ctx.loadingHub,
                options: _ctx.listHubDataList,
                keyName: "name",
                keyValue: "value",
                placeholder: _ctx.$t('userManagement.modalEditDetail.selectHub'),
                "model-value": _ctx.hubName,
                useInfiniteScroll: "",
                onFocus: _ctx.fetchListHub,
                "onUpdate:modelValue": _ctx.onSelectHub,
                onScrolled: _ctx.fetchListHubInfiniteScroll,
                isSelectedNotReset: true
              }, null, 8, ["isLoading", "options", "placeholder", "model-value", "onFocus", "onUpdate:modelValue", "onScrolled"])
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.type === 'division')
          ? (_openBlock(), _createBlock("div", {
              key: 5,
              style: { height: _ctx.focusListDivision ? '147px' : '46px' }
            }, [
              _createVNode(_component_SelectSearch, {
                onFilter: _ctx.fetchListDivision,
                onFocus: _ctx.focusListDivision,
                isLoading: _ctx.loadingDivision,
                options: _ctx.divisionDataList,
                keyName: "name",
                keyValue: "value",
                placeholder: _ctx.$t('userManagement.modalEditDetail.selectDivision'),
                "model-value": _ctx.divisionName,
                "onUpdate:modelValue": _ctx.onSelectDivision,
                isSelectedNotReset: true
              }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue"])
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.type === 'shuttle')
          ? (_openBlock(), _createBlock("div", {
              key: 6,
              style: { height: _ctx.focusListShuttle ? '147px' : '46px' }
            }, [
              _createVNode(_component_SelectSearch, {
                onFilter: _ctx.fetchListShuttle,
                onFocus: _ctx.focusListShuttle,
                isLoading: _ctx.loadingShuttle,
                options: _ctx.shuttleDataList,
                keyName: "name",
                keyValue: "value",
                placeholder: _ctx.$t('userManagement.modalEditDetail.selectShuttle'),
                "model-value": _ctx.shuttleName,
                "onUpdate:modelValue": _ctx.onSelectShuttle,
                isSelectedNotReset: true
              }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue"])
            ], 4))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_lp_button, {
            disabled: !_ctx.isFormValid,
            "text-color": "white",
            "custom-class": "px-10",
            title: _ctx.$t('userManagement.modalEditDetail.save'),
            onClick: _ctx.submitConfirmation
          }, null, 8, ["disabled", "title", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "onUpdate:modelValue"]))
})